export const MOVE_USERS_TO_BRANCH_URL =
  "https://form.jotform.com/242486670318866";
export const CREATE_USER_IN_BRANCH_URL =
  "https://form.jotform.com/231304672688057";
export const REMOVE_USER_FROM_BRANCH =
  "https://form.jotform.com/242487060573863";
export const PROMOTE_USER_TO_BRANCH_ADMIN_URL =
  "https://form.jotform.com/242487163006858";
export const REMOVE_BRANCH_ADMIN_URL =
  "https://form.jotform.com/242487539666877";
